const CDH = ({ color = '#E9BF6E', width = 24, height = 24 }: { color?: string; width?: number; height?: number }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.001 11.9999C21.553 11.9999 22.006 11.5509 21.951 11.0019C21.7205 8.70609 20.7031 6.56062 19.0713 4.92924C17.4396 3.29786 15.2939 2.28096 12.998 2.05092C12.448 1.99592 12 2.44892 12 3.00092V11.0009C12 11.2661 12.1054 11.5205 12.2929 11.708C12.4804 11.8956 12.7348 12.0009 13 12.0009L21.001 11.9999Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2104 15.8901C20.5742 17.3946 19.5792 18.7203 18.3123 19.7514C17.0454 20.7825 15.5452 21.4875 13.9428 21.8049C12.3405 22.1222 10.6848 22.0422 9.12055 21.5719C7.55627 21.1015 6.13103 20.2551 4.96942 19.1067C3.80782 17.9583 2.94522 16.5428 2.45704 14.984C1.96886 13.4252 1.86996 11.7706 2.169 10.1647C2.46804 8.55886 3.1559 7.05071 4.17245 5.77211C5.189 4.49351 6.50329 3.4834 8.0004 2.83008"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CDH;
